/**
 * ShowMeChip — non-disruptive navigation affordance.
 *
 * Persists in the transcript. Clicking it calls ui-actions.executeUiAction
 * with the action's route/params. User must explicitly click — never
 * auto-navigates.
 *
 * BEM class: .show-me-chip
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { executeUiAction } from '../../lib/tendril/ui-actions.js';
import '../../styles/components/tendril.css';

/**
 * @param {{
 *   action: { kind: string, route: string, params?: Record<string, string> },
 *   label?: string,
 * }} props
 */
export default function ShowMeChip({ action, label = 'Show me' }) {
  const navigate = useNavigate();

  function handleClick() {
    executeUiAction(action, navigate);
  }

  return (
    <button
      className="show-me-chip"
      onClick={handleClick}
      aria-label={`${label} — navigate to ${action?.route ?? 'page'}`}
      type="button"
    >
      {label}
      <span className="show-me-chip__arrow" aria-hidden="true">→</span>
    </button>
  );
}
